import { useEffect, useRef } from 'react';

/**
 * Auto-refreshes dashboard data when the browser tab becomes visible.
 * Calls the provided refresh function on visibilitychange events.
 */
export function useDashboardRefresh(refreshFn: () => void) {
  const refreshRef = useRef(refreshFn);
  refreshRef.current = refreshFn;

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refreshRef.current();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);
}
